import {monthNames, swal} from "@/common/constants/variables";
import { patchDocument, PatchType, TextRun} from "docx";
/**
 * Agrega la funcionalidad de arrastrar y soltar un archivo en una estructura HTML.
 * @param {Object} component - El componente.
 * @param {string} [variableNameFile=file] - El nombre de la variable donde se almacena el archivo cargado.
 */
export function enableUploadFileByDragger(component, variableNameFile = 'file') {
  [component.$refs.fileFormEnter, component.$refs.fileFormDrop, component.$refs.fileFormUploaded].forEach(function (element) {
    ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
      element.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
      }.bind(this), false);
    }.bind(this));
  });

  component.$refs.fileFormEnter.addEventListener('dragenter', function () {
    document.getElementById('contenedor_archivo').className = 'hidden';
    document.getElementById('drag_over').className = 'flex justify-center align-middle w-full';
  });

  component.$refs.fileFormDrop.addEventListener('dragleave', function () {
    document.getElementById('drag_over').className = 'hidden';
    if (component[variableNameFile] === undefined) document.getElementById('contenedor_archivo').className = 'flex items-center space-x-2 w-full';
    else document.getElementById('info_archivo').className = 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3';
  }.bind(this));

  component.$refs.fileFormUploaded.addEventListener('dragenter', function () {
    document.getElementById('info_archivo').className = 'hidden';
    document.getElementById('drag_over').className = 'flex justify-center align-middle w-full';
  });

  component.$refs.fileFormDrop.addEventListener('drop', function (e) {
    component[variableNameFile] = e.dataTransfer.files[0];
    uploadFile(component[variableNameFile]);
  }.bind(this));

  component.$refs.fileFormUploaded.addEventListener('drop', function (e) {
    component[variableNameFile] = e.dataTransfer.files[0];
    uploadFile(component[variableNameFile]);
  });
}

/**
 * Agregar los estilos y el contenido del archivo en el HTML de arrastrar y soltar.
 * @param {File} file - El archivo cargado.
 */
export function uploadFile(file, key = '') {
  if(document.getElementById('info_archivo' + key))
    document.getElementById('info_archivo' + key).className = 'font-bold block w-full flex flex-col justify-center align-middle gap-3 px-3';
    document.getElementById('nombre_archivo' + key).innerText = file.name;
    document.getElementById('contenedor_archivo' + key).className = 'hidden';
    document.getElementById('preview_archivo' + key).src = window.URL.createObjectURL(file);
    document.getElementById('drag_over' + key).className = 'hidden';
}

/**
 * Elimina los estilos y el contenido del archivo en el HTML de arrastrar y soltar.
 * @param {HTMLElement} elementParent - El elemento del padre que contiene la funcionalidad de arrastrar y soltar.
 */
export function removeFile(elementParent, key = '') {
  if (elementParent) {
    elementParent.querySelector('#info_archivo' + key).className = 'hidden';
    elementParent.querySelector('#nombre_archivo' + key).innerText = '';
    elementParent.querySelector('#contenedor_archivo' + key).className = 'flex items-center space-x-2 w-full';
    elementParent.querySelector('#preview_archivo' + key).src = '';
    elementParent.querySelector('#archivo' + key).value = '';
  }
}

/**
 * Extrae el texto de error de una respuesta del Backend.
 * @param {Object} resJSON - La respuesta del Backend.
 * @return {string} El texto de error.
 */
export function generateTextError(resJSON) {
  if (typeof resJSON.message === 'object') {
    resJSON.message[0] = '- ' + resJSON.message[0];
    return resJSON.message.join('<div></div>- ');
  } else return resJSON.message;
}

/**
 * Válida sí el código de estado HTTP es el esperado.
 * @param {number} statusCode - El código de estado HTTP.
 * @param {string} statusExpected - El estado esperado.
 * @return {boolean|Error} El resultado de la validación.
 */
export function verifyHttpCode(statusCode, statusExpected) {
  if (statusExpected === 'info') return statusCode >= 100 && statusCode < 200;
  else if (statusExpected === 'success') return statusCode >= 200 && statusCode < 300;
  else if (statusExpected === 'redirect') return statusCode >= 300 && statusCode < 400;
  else if (statusExpected === 'error') return statusCode >= 400 && statusCode < 500;
  else if (statusExpected === 'errorServer') return statusCode >= 500 && statusCode < 600;
  throw new Error('¡El StatusCode es invalido!');
}

/**
 * Reemplaza la palabra en search, de ”Activo” a ”1” y “Inactivo” a ”0”, sí el criterio es ”estado”.
 * @param {string} criterion - El criterio.
 * @param {string} search - La búsqueda.
 * @return {string} La búsqueda con las palabras actualizadas.
 */
export function filterCustomSearch(criterion, search) {
  const listCriterion = criterion.split(',');
  const listSearch = search.split(',');
  const indexEstado = listCriterion.indexOf('estado');
  if (indexEstado !== -1) {
    const searchEstado = listSearch[indexEstado];
    const searchMathActivo = searchEstado.match(/^A?c?t?i?v?o?$/gi);
    const searchMathInactivo = searchEstado.match(/^I?n?a?c?t?i?v?o?$/gi);
    const searchEstadoUpdated = searchMathActivo && searchMathActivo[0] ? '1' : (searchMathInactivo && searchMathInactivo[0] ? '0' : searchEstado);
    search = search.replace(searchEstado, searchEstadoUpdated);
  }
  return search;
}

/**
 * Formatea el número consecutivo de una cuenta bancaría agregándoles ceros al inicio hasta que el número llegue a los 12 dígitos.
 * @param {number|string} cuentaBancaria - La cuenta bancaría.
 * @return {string} La cuenta bancaría formateada.
 */
export const fixCuentaBancaria = (cuentaBancaria) => (typeof cuentaBancaria !== 'string' ? cuentaBancaria.toString() : cuentaBancaria).padStart(12, '0').match(/.{1,4}/g).join(' ');

/**
 * Obtiene la cantidad de los días de un mes, según el año y el mes.
 * @param {number} month - Número del mes.
 * @param {number} year - El año.
 * @return {number} La cantidad de días.
 */
export const getDaysInMonth = (month, year) => (new Array(31)).fill('').map((v, i) => new Date(year, month - 1, i + 1)).filter(v => v.getUTCMonth() === month - 1).length;

/**
 * Obtiene el nombre del mes según el número del mes.
 * @param {number} monthNumber - Número del mes.
 * @return {string} El nombre del mes.
 */
export const getCurrentMonth = (monthNumber) => {
  return monthNames[monthNumber - 1];
}

/**
 * Obtiene el número del mes según el nombre del mes.
 * @param {string} monthName - Nombre del mes.
 * @return {number} El número del mes.
 */
export const getNumberMonth = (monthName) => {
  return monthNames.map(monthName => monthName.toLowerCase()).indexOf(monthName.toLowerCase()) + 1;
}

/**
 * Obtiene la letra de la columna de Excel en base a un número.
 * @param {number} number - La palabra a transformar.
 * @return {string} La letra de la columna de Excel.
 */
export const getColNameByNumber = (number) => {
  const ordA = 'a'.charCodeAt(0);
  const ordZ = 'z'.charCodeAt(0);
  const len = ordZ - ordA + 1;
  let s = '';
  while (number >= 0) {
    s = String.fromCharCode((number % len) + ordA) + s;
    number = Math.floor(number / len) - 1;
  }
  return s.toUpperCase();
};

/**
 * Transforma la primera letra de una palabra en mayúscula.
 * @param {string} letter - La palabra a transformar.
 * @return {string} La palabra transformada.
 */
export const firstLetterCapitalize = (letter) => letter.charAt(0).toUpperCase() + letter.slice(1);

/**
 * Ordena las llaves de un diccionario alfabéticamente de manera ascendente.
 * @param {Object} dictionary - El diccionario a ordenar.
 * @return {Object} El diccionario ordenado.
 */
export const sortAlphaNumerically = (dictionary) => Object.entries(dictionary).sort(([keyA], [keyB]) => keyA.localeCompare(keyB, undefined, {numeric: true})).map(([key, prop]) => ({[key]: prop}))

/**
 * Formatea el número, agregándole 2 a 10 decimales.
 * @param {number|bigint} num - El número a formatear.
 * @return {string} El número formateado sí es válido.
 */
export const fixDecimals = (num) => new Intl.NumberFormat('es-CO', {
  style: 'decimal',
  useGrouping: false,
  minimumFractionDigits: 2,
  maximumFractionDigits: 10
}).format(num).replace(',', '.');

/**
 * Formatea el número a un precio colombiano, si es válido.
 * @param {string|number} num - El número a formatear.
 * @return {string|number} El número formateado sí es válido.
 */
export const separateNumberByComma = (num) => {
  if (num) {
    if (typeof num !== 'number') num = Number(num);
    return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }
}

/**
 * Formatea el número a un precio colombiano, si es válido, soportado para ser utilizado en un Input de tipo text.
 * @param {string} num - El número a formatear.
 * @return {string} El número formateado sí es válido.
 */
export const separateNumberByCommaInput = (num) => {
    let result = '';
    const isNegative = num.includes('-');
    num.split('').map(number => {
        if (number !== '.') result += number.replace(/\D/g, "");
        else if (!result.match(/\./g)) result += number;
    });
    let isDecimal = false;
    result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (isNegative) {
        result = '-' + result.replace('-', '');
    }
    return result
        .split('')
        .map(num => {
            if (num === '.') isDecimal = true;
            else if (isDecimal && num === ',') return '';
            return num;
        })
        .join('');
}

/**
 * Hace una copia profunda del valor de una variable, evitando el ShallowCopy.
 * @param {Object} value - La variable original.
 * @return {Object} La variable clonada.
 */
export const copiaProfunda = (value) => JSON.parse(JSON.stringify(value));

/**
 * Construye la URL de un archivo servido desde `public/`, respetando el
 * subdirectorio donde esté publicada la aplicación.
 *
 * Las rutas absolutas del tipo `/assets/...` apuntan siempre a la raíz del
 * dominio, así que se rompen cuando el front se despliega bajo un path
 * (por ejemplo `https://dominio/tesoreria_front/`): el `fetch` devuelve el
 * index.html con 404 en lugar del archivo. `process.env.BASE_URL` lo inyecta
 * Vue CLI con el `publicPath` del build y siempre termina en `/`.
 *
 * @param {string} ruta - Ruta del archivo relativa a `public/` (con o sin `/` inicial).
 * @return {string} La URL completa lista para `fetch` o para el atributo `src`.
 */
export const assetUrl = (ruta) => {
  const base = process.env.BASE_URL || '/';
  return `${base.endsWith('/') ? base : base + '/'}${String(ruta).replace(/^\/+/, '')}`;
};

/**
 * Plantillas .docx de los oficios de embargo, en un solo lugar para que la
 * generación y la precarga no puedan quedar apuntando a rutas distintas.
 */
export const PLANTILLAS_OFICIOS_EMBARGO = {
  confirmacion_vinculacion: 'assets/oficios_embargos/oficio_confirmacion_vinculacion.docx',
  traslado_competencia: 'assets/oficios_embargos/oficio_notificacion_traslado_competencia.docx',
  confirmado_contratista: 'assets/oficios_embargos/oficio_notificacion_confirmado_contratista.docx',
};

const plantillasEnMemoria = new Map();

const esperar = (milisegundos) => new Promise((resolve) => setTimeout(resolve, milisegundos));

/**
 * Un intento de descarga de plantilla.
 *
 * `fetch` no lanza excepción ante un 404: la SPA responde el index.html y el
 * blob resultante es HTML, con lo que el parcheo del documento falla después
 * con un error de ZIP ilegible. Se valida la respuesta aquí para que el
 * problema real (plantilla no desplegada o ruta equivocada) quede explícito.
 *
 * Los errores que no tiene sentido reintentar (la plantilla no está publicada)
 * se marcan con `definitivo` para que el reintento no los repita en vano.
 *
 * @param {string} urlPlantilla - URL absoluta de la plantilla.
 * @return {Promise<Blob>} El contenido de la plantilla.
 */
const descargarPlantilla = async (urlPlantilla) => {
  let response;

  try {
    response = await fetch(urlPlantilla, { cache: 'no-cache' });
  } catch (errorRed) {
    throw new Error(`No se pudo descargar la plantilla ${urlPlantilla}: el navegador no recibió respuesta del servidor (${errorRed.message}). Abra esa dirección en una pestaña para verificar que el archivo esté publicado y que no lo bloquee el proxy, el firewall o el antivirus.`);
  }

  if (!response.ok) {
    const error = new Error(`No se encontró la plantilla del documento en ${urlPlantilla} (HTTP ${response.status}).`);
    error.definitivo = true;
    throw error;
  }

  const data = await response.blob();

  if (data.type && data.type.includes('text/html')) {
    const error = new Error(`La ruta ${urlPlantilla} no devolvió un documento de Word. Verifique que la plantilla esté publicada en el servidor.`);
    error.definitivo = true;
    throw error;
  }

  if (data.size < 1024) {
    throw new Error(`La plantilla ${urlPlantilla} se descargó incompleta (${data.size} bytes). Vuelva a publicar el archivo en el servidor.`);
  }

  return data;
};

/**
 * Descarga una plantilla .docx de `public/` como blob, con caché en memoria y
 * reintentos.
 *
 * La descarga falla de forma intermitente cuando un antivirus o proxy corta la
 * conexión al ver el binario del .docx: el mismo archivo que no baja en un
 * intento baja bien al siguiente. Por eso se reintenta antes de dar el error, y
 * una vez que la plantilla bajó bien se conserva para el resto de la sesión.
 *
 * @param {string} rutaPlantilla - URL de la plantilla, normalmente vía `assetUrl`.
 * @param {Object} [opciones]
 * @param {number} [opciones.intentos=3] - Número de descargas a probar antes de fallar.
 * @return {Promise<Blob>} El contenido de la plantilla.
 */
export const fetchPlantilla = async (rutaPlantilla, { intentos = 3 } = {}) => {
  const urlPlantilla = new URL(rutaPlantilla, document.baseURI).href;

  if (plantillasEnMemoria.has(urlPlantilla)) return plantillasEnMemoria.get(urlPlantilla);

  let ultimoError;

  for (let intento = 1; intento <= intentos; intento++) {
    try {
      const data = await descargarPlantilla(urlPlantilla);
      plantillasEnMemoria.set(urlPlantilla, data);
      return data;
    } catch (error) {
      ultimoError = error;
      if (error.definitivo) break;
      if (intento < intentos) await esperar(400 * intento);
    }
  }

  throw ultimoError;
};

/**
 * Deja en memoria las plantillas de los oficios de embargo.
 *
 * Se llama al entrar al módulo de Oficios para que la descarga ocurra mientras
 * el usuario diligencia el formulario y no en el momento de generar: así un
 * corte de red no deja el oficio registrado sin su documento. Los fallos se
 * ignoran a propósito — es una optimización, y si ninguna plantilla alcanzó a
 * quedar en caché la generación vuelve a intentarlo y reporta el error real.
 *
 * @return {Promise<void>}
 */
export const precargarPlantillasOficios = async () => {
  await Promise.all(
    Object.values(PLANTILLAS_OFICIOS_EMBARGO)
      .map((ruta) => fetchPlantilla(assetUrl(ruta)).catch(() => null))
  );
};

/**
 * Descarga un archivo de `public/` (plantillas de cargue, formatos, etc.).
 *
 * Resuelve dos fallas que tenía el enlace `<a href download>` estático puesto
 * directamente en la plantilla del componente:
 *
 * @param {string} ruta - Ruta del archivo relativa a `public/`.
 * @param {string} nombreArchivo - Nombre con el que se guarda la descarga.
 * @return {Promise<void>}
 */
export const descargarAsset = async (ruta, nombreArchivo) => {
  const url = `${assetUrl(ruta)}?v=${Date.now()}`;

  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombreArchivo;
  enlace.rel = 'noopener';
  enlace.style.display = 'none';

  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
};

/**
 * Realiza consultas APIRest a través de fetch.
 * @param {string} urlAPI - La API a consumir.
 * @param {string} method - El método de petición HTTP.
 * @param {string} [authToken] - El token de autentificación.
 * @param {Object} [body] - El body de la petición.
 * @param {Object} [query] - La query de la petición, cada llave y valor son formateadas para ser enviados en la URL.
 * @param {string} [contentType=application/json] - El content-type de la petición.
 * @param {string} [credentials=same-origin] - Las "credentails" del fetch.
 * @return {Promise<Response>} La promesa de la petición.
 */
export const useAPIRest = async (urlAPI, method, authToken = undefined, body = {}, query = {}, contentType = 'application/json', credentials = 'same-origin') => {
  if (query.constructor === Object && Object.keys(query).length) {
    let countQuery = 0;
    for (const queryKey in query) {
      const queryValue = query[queryKey];
      if (queryValue !== undefined) {
        urlAPI += `${countQuery ? '&' : '?'}${queryKey}=${queryValue}`;
        countQuery++;
      }
    }
  }
  const init = {
    method,
    headers: {},
    credentials
  };
  if ([Object, Array].includes(body.constructor) && Object.keys(body).length) init['body'] = JSON.stringify(body);
  else if (body.constructor !== Object) init['body'] = body;
  if (contentType !== 'auto') init['headers']['Content-Type'] = contentType;
  if (typeof authToken === 'string') init['headers']['Authorization'] = authToken;
  init['headers']['Access-Control-Allow-Headers'] = "Origin, Content-Type, X-Auth-Token";
  init['headers']['Access-Control-Allow-Origin'] = ['http://35.243.151.84:3000','http://localhost:8080/'];
  init['headers']['access-control-allow-credentials'] = true;

  return await fetch(urlAPI, init).then(async res => {
    let resJSON;
    const resClone = res.clone();
    try {
      resJSON = await resClone.json();
    } catch (_) {
      resJSON = res;
    }
    // Un cuerpo que parsea a null o a un primitivo no admite propiedades: se
    // envuelve para no reventar al asignarle el statusCode.
    if (resJSON === null || typeof resJSON !== 'object') resJSON = {data: resJSON};
    resJSON.statusCode = res.status === resJSON.statusCode ? resJSON.statusCode : res.status;
    return resJSON;
  }).catch((error) => {
    console.error(error);
    swal.fire('Error inesperado. Informar al administrador.', '', 'error');
    // Nunca resolver como undefined: los llamadores desestructuran el resultado
    // (p. ej. `const {token} = resJSON`), y un undefined convierte cualquier
    // fallo de red en un TypeError que oculta la causa real.
    return {statusCode: 503, message: 'No fue posible conectar con el servidor.', error: error?.message};
  });
};

/**
 * Obtiene las queries por defecto para la API de listar cuando se utiliza la paginación, utilizada en el useLayoutMain.
 * @return {Object} Las queries en un diccionario.
 */
export const getPaginate = () => ({
  "page": 1,
  "take": 10,
  "itemCount": 0,
  "pageCount": 1,
  "hasPreviousPage": false,
  "hasNextPage": false
});

/**
 * Obtiene las queries por defecto para la API de listar cuando se realiza búsquedas por filtros, utilizada en el useLayoutMain.
 * @return {Object} Las queries en un diccionario.
 */
export const getQueries = () => ({
  "orderBy": 'created_at',
  "order": 'ASC',
  "criterion": '',
  "search": ''
});

export const downloadChargeAccount = async (anioExtracto, mesExtracto, authToken, noPagados, tasa_efectiva_anual_id) => {
  //El extracto y la plantilla no dependen entre sí, así que se resuelven en paralelo.
  const [extractoBancario, data] = await Promise.all([
    useAPIRest(process.env.VUE_APP_NEST_EXTRACTOBANCARIO_FINDONEBYYEARMONTH.replace(':year', anioExtracto).replace(':month', mesExtracto).replace(':tasa_efectiva_anual_id', tasa_efectiva_anual_id), 'GET', authToken),
    fetch(assetUrl('assets/informes_rendimientos/formato_reintegro_rendimientos_financieros.docx')).then(response => response.blob())
  ])

  //Se valida el extracto antes de pedir el consecutivo, porque cada llamada a nextVal lo incrementa de forma permanente.
  if (!extractoBancario?.bancoTasaEfectivaAnual?.cuentaBancaria?.banco)
    throw new Error(`No se encontró el extracto bancario de ${mesExtracto}-${anioExtracto} para la cuenta seleccionada.`)

  const consecutivo = (await useAPIRest(process.env.VUE_APP_NEST_SECUENCIACUENTACOBRO_NEXTVAL, 'PATCH', authToken)).secuencia_actual.toString()

  const fechaActual = new Date();

  const doc = await patchDocument(data, {
    patches: {
      consecutivo: {
        type: PatchType.PARAGRAPH, 
        children: [
          new TextRun({text: consecutivo, bold: true, size: 24, font: 'Arial'}),
        ],
      },

      dia_actual: {
        type: PatchType.PARAGRAPH,
        children: [
          new TextRun({text: fechaActual.getDate().toString(), size: 24, font: 'Arial'}),
        ]
      },

      mes_actual: {
        type: PatchType.PARAGRAPH,
        children: [
          new TextRun({text: getCurrentMonth(fechaActual.getMonth() + 1), size: 24, font: 'Arial'}),
        ]
      },

      anio_actual: {
        type: PatchType.PARAGRAPH,
        children: [
          new TextRun({text: fechaActual.getFullYear().toString(), size: 24, font: 'Arial'}),
        ]
      },

      nombre_banco: {
        type: PatchType.PARAGRAPH, 
        children: [
          new TextRun({text: extractoBancario.bancoTasaEfectivaAnual.cuentaBancaria.banco.nombre_banco.toUpperCase(), bold: true, size: 24, font: 'Arial'}),
        ],
      },
      mes_extracto: {
        type: PatchType.PARAGRAPH,
        children: [
          new TextRun({text: getCurrentMonth(extractoBancario.mes).toLowerCase(), size: 24, font: 'Arial'}),
        ]
      },
      anio_extracto: {
        type: PatchType.PARAGRAPH,
        children: [
          new TextRun({text: extractoBancario.year.toString(), size: 24, font: 'Arial'}),
        ]
      },
      numero_cuenta: {
        type: PatchType.PARAGRAPH, 
        children: [
          new TextRun({text: extractoBancario.bancoTasaEfectivaAnual.cuentaBancaria.cuenta_bancaria, bold: true, size: 24, font: 'Arial'}),
        ],
      },
      nombre_cuenta: {
        type: PatchType.PARAGRAPH, 
        children: [
          new TextRun({text: extractoBancario.bancoTasaEfectivaAnual.cuentaBancaria.nombre_cuenta, bold: true, size: 24, font: 'Arial'}),
        ],
      },
      diferencia_por_cobrar: {
        type: PatchType.PARAGRAPH, 
        children: [
          new TextRun({text: separateNumberByComma(+noPagados), bold: true, size: 24, font: 'Arial'}),
        ],
      },
    },
  });

  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(new Blob([doc], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
  downloadLink.download = 'cuenta_cobro_' + anioExtracto + '_' + mesExtracto + '_' + extractoBancario.bancoTasaEfectivaAnual.cuentaBancaria.banco.nombre_banco;
  downloadLink.click();
};

/**
 * Genera y descarga el oficio de un embargo a persona (R1) parcheando la
 * plantilla .docx correspondiente al tipo de oficio (patrón downloadChargeAccount).
 * @param {Object} oficio - Registro del oficio (consecutivo, tipo_oficio, fecha_generacion).
 * @param {Object} dataEmbargo - Datos del embargo (demandado, demandante, proceso...).
 * @param {string} destinos - Nombres de los destinos seleccionados (separados por coma).
 * @param {string} consecutivoConfirmacion - Consecutivo del oficio de confirmación referenciado (solo notificación).
 */
export const downloadOficioEmbargo = async (oficio, dataEmbargo, destinos = '', consecutivoConfirmacion = '') => {
  // El oficio de notificación (DFT) tiene dos redacciones oficiales según la
  // variante seleccionada, que viaja en `variante_notificacion` con valor
  // 'traslado_competencia' o 'confirmado_contratista'.
  const rutaPlantilla = oficio.tipo_oficio === 'confirmacion_vinculacion'
    ? assetUrl(PLANTILLAS_OFICIOS_EMBARGO.confirmacion_vinculacion)
    : assetUrl(PLANTILLAS_OFICIOS_EMBARGO[oficio.variante_notificacion] || PLANTILLAS_OFICIOS_EMBARGO.traslado_competencia);

  const data = await fetchPlantilla(rutaPlantilla);

  const fechaGeneracion = oficio.fecha_generacion ? new Date(oficio.fecha_generacion + 'T00:00:00') : new Date();
  const nombreCompleto = (persona) => ((persona.primer_nombre || '') + ' ' + (persona.segundo_nombre || '') + ' ' + (persona.primer_apellido || '') + ' ' + (persona.segundo_apellido || '')).replace(/\s+/g, ' ').trim();

  const parche = (texto, bold = false) => ({
    type: PatchType.PARAGRAPH,
    children: [new TextRun({ text: String(texto ?? ''), bold, size: 22, font: 'Arial' })],
  });

  const doc = await patchDocument(data, {
    patches: {
      consecutivo: parche(oficio.consecutivo, true),
      dia_actual: parche(fechaGeneracion.getDate()),
      mes_actual: parche(getCurrentMonth(fechaGeneracion.getMonth() + 1)),
      anio_actual: parche(fechaGeneracion.getFullYear()),
      referencia: parche((dataEmbargo.entidadEmisora?.nombre ?? dataEmbargo.entidad_notifica_embargo) || ('Proceso N° ' + (dataEmbargo.numero_proceso || ''))),
      radicacion_proceso: parche(dataEmbargo.numero_proceso, true),
      juzgado: parche((dataEmbargo.entidadEmisora?.nombre ?? dataEmbargo.entidad_notifica_embargo), true),
      oficio_no: parche(dataEmbargo.numero_oficio),
      numero_proceso: parche(dataEmbargo.numero_proceso, true),
      entidad_notifica_embargo: parche((dataEmbargo.entidadEmisora?.nombre ?? dataEmbargo.entidad_notifica_embargo)),
      numero_oficio_embargo: parche(dataEmbargo.numero_oficio),
      fecha_oficio_embargo: parche(dataEmbargo.fecha_oficio),
      demandante: parche(nombreCompleto(dataEmbargo.demandante)),
      identificacion_demandante: parche(dataEmbargo.demandante.identificacion),
      demandado: parche(nombreCompleto(dataEmbargo.demandado), true),
      identificacion_demandado: parche(dataEmbargo.demandado.identificacion, true),
      valor_embargo: parche(separateNumberByComma(dataEmbargo.valor_inicial ?? '0'), true),
      destinos: parche(destinos, true),
      destinatario_nombre: parche(''),
      destinatario_cargo: parche(destinos),
      ciudad_destinatario: parche(''),
      consecutivo_confirmacion: parche(consecutivoConfirmacion, true),
    },
  });

  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(new Blob([doc], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
  downloadLink.download = 'oficio_' + oficio.tipo_oficio + '_' + oficio.consecutivo + '_proceso_' + dataEmbargo.numero_proceso;
  downloadLink.click();
};

/**
 * Genera y descarga el documento de liquidación de embargo para firma del
 * Director Financiero (R3), parcheando formato_liquidacion_embargo.docx.
 * @param {Object} liquidacion - Registro de la liquidación (valor, base_calculo, porcentaje_aplicado, modalidad...).
 * @param {Object} dataEmbargo - Datos del embargo (demandado, demandante, proceso...).
 */
export const downloadLiquidacionEmbargo = async (liquidacion, dataEmbargo) => {
  const data = await fetchPlantilla(assetUrl('assets/oficios_embargos/formato_liquidacion_embargo.docx'));

  const fechaActual = new Date();
  const nombreCompleto = (persona) => ((persona.primer_nombre || '') + ' ' + (persona.segundo_nombre || '') + ' ' + (persona.primer_apellido || '') + ' ' + (persona.segundo_apellido || '')).replace(/\s+/g, ' ').trim();

  const parche = (texto, bold = false) => ({
    type: PatchType.PARAGRAPH,
    children: [new TextRun({ text: String(texto ?? ''), bold, size: 24, font: 'Arial' })],
  });

  const doc = await patchDocument(data, {
    patches: {
      consecutivo: parche(liquidacion.consecutivo_oficio ?? liquidacion.id ?? '', true),
      dia_actual: parche(fechaActual.getDate()),
      mes_actual: parche(getCurrentMonth(fechaActual.getMonth() + 1)),
      anio_actual: parche(fechaActual.getFullYear()),
      numero_proceso: parche(dataEmbargo.numero_proceso, true),
      entidad_notifica_embargo: parche((dataEmbargo.entidadEmisora?.nombre ?? dataEmbargo.entidad_notifica_embargo)),
      numero_oficio_embargo: parche(dataEmbargo.numero_oficio),
      fecha_oficio_embargo: parche(dataEmbargo.fecha_oficio),
      demandante: parche(nombreCompleto(dataEmbargo.demandante)),
      identificacion_demandante: parche(dataEmbargo.demandante.identificacion),
      demandado: parche(nombreCompleto(dataEmbargo.demandado), true),
      identificacion_demandado: parche(dataEmbargo.demandado.identificacion, true),
      valor_embargo: parche(separateNumberByComma(dataEmbargo.valor_inicial ?? '0'), true),
      modalidad: parche(liquidacion.modalidad ? liquidacion.modalidad.nombre : 'Manual', true),
      base_calculo: parche(separateNumberByComma(liquidacion.base_calculo ?? '0')),
      porcentaje_aplicado: parche(liquidacion.porcentaje_aplicado != null ? liquidacion.porcentaje_aplicado + ' %' : 'N/A'),
      valor_liquidado: parche(separateNumberByComma(liquidacion.valor ?? '0'), true),
      saldo_actual: parche(separateNumberByComma(liquidacion.saldo_actual ?? dataEmbargo.valor_actual ?? '0')),
    },
  });

  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(new Blob([doc], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
  downloadLink.download = 'liquidacion_embargo_proceso_' + dataEmbargo.numero_proceso;
  downloadLink.click();
};

// ------------------------------ Número a letras (formato legal colombiano) ---
const LETRAS_UNIDADES = ['', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE',
  'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE',
  'VEINTE', 'VEINTIUNO', 'VEINTIDÓS', 'VEINTITRÉS', 'VEINTICUATRO', 'VEINTICINCO', 'VEINTISÉIS', 'VEINTISIETE', 'VEINTIOCHO', 'VEINTINUEVE'];
const LETRAS_DECENAS = ['', '', '', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
const LETRAS_CENTENAS = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

// Convierte un entero de 0 a 999 a letras.
const centenasALetras = (n) => {
  if (n === 0) return '';
  if (n === 100) return 'CIEN';
  let texto = '';
  const c = Math.floor(n / 100);
  const resto = n % 100;
  if (c) texto += LETRAS_CENTENAS[c];
  if (resto) {
    if (texto) texto += ' ';
    if (resto < 30) texto += LETRAS_UNIDADES[resto];
    else {
      const d = Math.floor(resto / 10);
      const u = resto % 10;
      texto += LETRAS_DECENAS[d] + (u ? ' Y ' + LETRAS_UNIDADES[u] : '');
    }
  }
  return texto;
};

// Apócope de "uno" → "un" cuando precede a un sustantivo masculino (mil, pesos).
const apocoparUno = (texto) => texto.replace(/VEINTIUNO$/, 'VEINTIÚN').replace(/\bUNO$/, 'UN');

// Convierte un entero no negativo a letras (hasta miles de millones).
const enteroALetras = (n) => {
  if (n === 0) return 'CERO';
  const millones = Math.floor(n / 1000000);
  const miles = Math.floor((n % 1000000) / 1000);
  const resto = n % 1000;
  let texto = '';
  if (millones) texto += millones === 1 ? 'UN MILLÓN' : centenasALetras(millones) + ' MILLONES';
  if (miles) {
    if (texto) texto += ' ';
    texto += miles === 1 ? 'MIL' : apocoparUno(centenasALetras(miles)) + ' MIL';
  }
  if (resto) {
    if (texto) texto += ' ';
    texto += centenasALetras(resto);
  }
  return texto.trim();
};

/**
 * Convierte un valor monetario a su representación legal en letras, p. ej.
 * 8818055.85 → "OCHO MILLONES OCHOCIENTOS DIECIOCHO MIL CINCUENTA Y CINCO PESOS
 * CON 85/100 MONEDA CORRIENTE".
 * @param {number|string} valor - Valor a convertir.
 * @return {string} El valor en letras mayúsculas.
 */
export const valorEnLetras = (valor) => {
  const numero = Math.abs(Number(valor) || 0);
  const entero = Math.floor(numero);
  const centavos = Math.round((numero - entero) * 100);
  const enLetras = apocoparUno(enteroALetras(entero));
  const peso = entero === 1 ? 'PESO' : 'PESOS';
  return `${enLetras} ${peso} CON ${String(centavos).padStart(2, '0')}/100 MONEDA CORRIENTE`;
};

/**
 * Genera y descarga el oficio de notificación al Área Jurídica (punto 6),
 * parcheando oficio_notificacion_juridica.docx con la información registrada de
 * la notificación, su comprobante de egreso asociado y los datos del embargo,
 * conforme al formato oficial.
 * @param {Object} notificacion - Registro de notificación jurídica (numero_oficio, fecha_envio, numero_cuenta_afectada, concepto_recurso, egreso...).
 * @param {Object} dataEmbargo - Datos del embargo (demandante, proceso, entidad emisora...).
 */
export const downloadNotificacionJuridica = async (notificacion, dataEmbargo) => {
  const data = await fetchPlantilla(assetUrl('assets/oficios_embargos/oficio_notificacion_juridica.docx'));

  const fechaEnvio = notificacion.fecha_envio ? new Date(notificacion.fecha_envio + 'T00:00:00') : new Date();
  const fechaOficioJuzgado = dataEmbargo.fecha_oficio ? new Date(dataEmbargo.fecha_oficio + 'T00:00:00') : null;
  const fechaLarga = (fecha) => fecha ? `${fecha.getDate()} de ${getCurrentMonth(fecha.getMonth() + 1).toLowerCase()} de ${fecha.getFullYear()}` : '';
  const nombreCompleto = (persona) => ((persona?.primer_nombre || '') + ' ' + (persona?.segundo_nombre || '') + ' ' + (persona?.primer_apellido || '') + ' ' + (persona?.segundo_apellido || '')).replace(/\s+/g, ' ').trim();
  const pesosColombianos = (valor) => '$' + new Intl.NumberFormat('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(valor) || 0);

  const parche = (texto, bold = false) => ({
    type: PatchType.PARAGRAPH,
    children: [new TextRun({ text: String(texto ?? ''), bold, size: 22, font: 'Arial' })],
  });

  const egreso = notificacion.egreso || {};
  const juzgado = dataEmbargo.entidadEmisora?.nombre ?? dataEmbargo.entidad_notifica_embargo ?? '';
  const banco = egreso.banco?.nombre_banco ?? '';
  const anioEgreso = egreso.fecha_comprobante ? new Date(egreso.fecha_comprobante + 'T00:00:00').getFullYear() : '';

  const doc = await patchDocument(data, {
    patches: {
      consecutivo: parche(notificacion.numero_oficio, true),
      dia_actual: parche(fechaEnvio.getDate()),
      mes_actual: parche(getCurrentMonth(fechaEnvio.getMonth() + 1)),
      anio_actual: parche(fechaEnvio.getFullYear()),
      destinatario_nombre: parche('', true),
      demandante: parche(nombreCompleto(dataEmbargo.demandante), true),
      identificacion_demandante: parche(dataEmbargo.demandante?.identificacion ?? '', true),
      fecha_oficio: parche(fechaLarga(fechaOficioJuzgado), true),
      juzgado: parche(juzgado, true),
      numero_proceso: parche(dataEmbargo.numero_proceso, true),
      banco: parche(banco, true),
      valor_letras: parche(valorEnLetras(egreso.valor ?? '0'), true),
      valor_numero: parche(pesosColombianos(egreso.valor ?? '0'), true),
      numero_cuenta: parche(notificacion.numero_cuenta_afectada ?? '', true),
      concepto_recurso: parche(notificacion.concepto_recurso ?? ''),
      numero_egreso: parche(egreso.numero ?? '', true),
      anio_egreso: parche(anioEgreso, true),
    },
  });

  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(new Blob([doc], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
  downloadLink.download = 'notificacion_juridica_' + (notificacion.numero_oficio || '') + '_proceso_' + dataEmbargo.numero_proceso;
  downloadLink.click();
};